var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgObjectSelection = function SvgObjectSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".object-selection_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 13.998,
    r: 8.5,
    className: "object-selection_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.405 3.242a.5.5 0 0 1 .188-.932l6.278-.739a.5.5 0 0 1 .555.555L21.7 8.34a.5.5 0 0 1-.934.184 12.78 12.78 0 0 0-5.361-5.282M11.5 18.5v-6a1 1 0 0 0-1-1h-1M9.5 18.498h4M11.5 9a.25.25 0 1 0 .25.25.25.25 0 0 0-.25-.25",
    className: "object-selection_svg__a"
  })));
};
export default SvgObjectSelection;